module.exports = __webpack_public_path__ + "static/img/icon_s3.9c28388.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_s3.png
// module id = RWGp
// module chunks = 21